import React from 'react';
import { Button } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const CancelAndSaveButtons = ({
  formId,
  onClose,
  dataAnalyticsId = undefined,
  isLoading,
  isDisabled
}) => (
  <>
    <Button
      variant="secondary"
      onClick={onClose}
    >
      Cancel
    </Button>
    <Button
      data-analytics-id={dataAnalyticsId}
      dusk={dataAnalyticsId}
      form={formId}
      isDisabled={isDisabled}
      isLoading={isLoading}
      ml={8}
      type="submit"
      variant="primary"
    >
      Save
    </Button>
  </>
);

CancelAndSaveButtons.propTypes = {
  formId: PropTypes.string,
  onClose: PropTypes.func,
  dataAnalyticsId: PropTypes.string,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool
};

export default CancelAndSaveButtons;
